import { TFunction } from "i18next";

export const GENDER_OPTIONS = [
    { label: "male", value: "male" },
    { label: "female", value: "female" },
];

export const CITIES_OPTIONS =
    [
        {
            name: "Aïn Harrouda",
            slug: "ain-harrouda"
        },
        {
            name: "Ben Yakhlef",
            slug: "ben-yakhlef"
        },
        {
            name: "Bouskoura",
            slug: "bouskoura"
        },
        {
            name: "Casablanca",
            slug: "casablanca"
        },
        {
            name: "Médiouna",
            slug: "mediouna"
        },
        {
            name: "Mohammadia",
            slug: "mohammadia"
        },
        {
            name: "Tit Mellil",
            slug: "tit-mellil"
        },
        {
            name: "Bejaâd",
            slug: "bejaad"
        },
        {
            name: "Ben Ahmed",
            slug: "ben-ahmed"
        },
        {
            name: "Benslimane",
            slug: "benslimane"
        },
        {
            name: "Berrechid",
            slug: "berrechid"
        },
        {
            name: "Boujniba",
            slug: "boujniba"
        },
        {
            name: "Boulanouare",
            slug: "boulanouare"
        },
        {
            name: "Bouznika",
            slug: "bouznika"
        },
        {
            name: "Deroua",
            slug: "deroua"
        },
        {
            name: "El Borouj",
            slug: "el-borouj"
        },
        {
            name: "El Gara",
            slug: "el-gara"
        },
        {
            name: "Guisser",
            slug: "guisser"
        },
        {
            name: "Hattane",
            slug: "hattane"
        },
        {
            name: "Khouribga",
            slug: "khouribga"
        },
        {
            name: "Loulad",
            slug: "loulad"
        },
        {
            name: "Oued Zem",
            slug: "oued-zem"
        },
        {
            name: "Oulad Abbou",
            slug: "oulad-abbou"
        },
        {
            name: "Oulad H'Riz Sahel",
            slug: "oulad-hriz-sahel"
        },
        {
            name: "Oulad M'rah",
            slug: "oulad-mrah"
        },
        {
            name: "Oulad Saïd",
            slug: "oulad-said"
        },
        {
            name: "Oulad Sidi Ben Daoud",
            slug: "oulad-sidi-ben-daoud"
        },
        {
            name: "Ras El Aïn",
            slug: "ras-el-ain"
        },
        {
            name: "Settat",
            slug: "settat"
        },
        {
            name: "Sidi Rahhal Chataï",
            slug: "sidi-rahhal-chatai"
        },
        {
            name: "Soualem",
            slug: "soualem"
        },
        {
            name: "Azemmour",
            slug: "azemmour"
        },
        {
            name: "Bir Jdid",
            slug: "bir-jdid"
        },
        {
            name: "Bouguedra",
            slug: "bouguedra"
        },
        {
            name: "Echemmaia",
            slug: "echemmaia"
        },
        {
            name: "El Jadida",
            slug: "el-jadida"
        },
        {
            name: "Hrara",
            slug: "hrara"
        },
        {
            name: "Ighoud",
            slug: "ighoud"
        },
        {
            name: "Jamâat Shaim",
            slug: "jamaat-shaim"
        },
        {
            name: "Jorf Lasfar",
            slug: "jorf-lasfar"
        },
        {
            name: "Khemis Zemamra",
            slug: "khemis-zemamra"
        },
        {
            name: "Laaounate",
            slug: "laaounate"
        },
        {
            name: "Moulay Abdallah",
            slug: "moulay-abdallah"
        },
        {
            name: "Oualidia",
            slug: "oualidia"
        },
        {
            name: "Oulad Amrane",
            slug: "oulad-amrane"
        },
        {
            name: "Oulad Frej",
            slug: "oulad-frej"
        },
        {
            name: "Oulad Ghadbane",
            slug: "oulad-ghadbane"
        },
        {
            name: "Safi",
            slug: "safi"
        },
        {
            name: "Sebt El Maârif",
            slug: "sebt-el-maarif"
        },
        {
            name: "Sebt Gzoula",
            slug: "sebt-gzoula"
        },
        {
            name: "Sidi Ahmed",
            slug: "sidi-ahmed"
        },
        {
            name: "Sidi Ali Ban Hamdouche",
            slug: "sidi-ali-ban-hamdouche"
        },
        {
            name: "Sidi Bennour",
            slug: "sidi-bennour"
        },
        {
            name: "Sidi Bouzid",
            slug: "sidi-bouzid"
        },
        {
            name: "Sidi Smaïl",
            slug: "sidi-smail"
        },
        {
            name: "Youssoufia",
            slug: "youssoufia"
        },
        {
            name: "Fès",
            slug: "fes"
        },
        {
            name: "Aïn Cheggag",
            slug: "ain-cheggag"
        },
        {
            name: "Bhalil",
            slug: "bhalil"
        },
        {
            name: "Boulemane",
            slug: "boulemane"
        },
        {
            name: "El Menzel",
            slug: "el-menzel"
        },
        {
            name: "Guigou",
            slug: "guigou"
        },
        {
            name: "Imouzzer Kandar",
            slug: "imouzzer-kandar"
        },
        {
            name: "Imouzzer Marmoucha",
            slug: "imouzzer-marmoucha"
        },
        {
            name: "Missour",
            slug: "missour"
        },
        {
            name: "Moulay Yaâcoub",
            slug: "moulay-yaacoub"
        },
        {
            name: "Ouled Tayeb",
            slug: "ouled-tayeb"
        },
        {
            name: "Outat El Haj",
            slug: "outat-el-haj"
        },
        {
            name: "Ribate El Kheir",
            slug: "ribate-el-kheir"
        },
        {
            name: "Séfrou",
            slug: "sefrou"
        },
        {
            name: "Skhinate",
            slug: "skhinate"
        },
        {
            name: "Tafajight",
            slug: "tafajight"
        },
        {
            name: "Arbaoua",
            slug: "arbaoua"
        },
        {
            name: "Aïn Dorij",
            slug: "ain-dorij"
        },
        {
            name: "Dar Gueddari",
            slug: "dar-gueddari"
        },
        {
            name: "Had Kourt",
            slug: "had-kourt"
        },
        {
            name: "Jorf El Melha",
            slug: "jorf-el-melha"
        },
        {
            name: "Kénitra",
            slug: "kenitra"
        },
        {
            name: "Khenichet",
            slug: "khenichet"
        },
        {
            name: "Lalla Mimouna",
            slug: "lalla-mimouna"
        },
        {
            name: "Mechra Bel Ksiri",
            slug: "mechra-bel-ksiri"
        },
        {
            name: "Mehdia",
            slug: "mehdia"
        },
        {
            name: "Moulay Bousselham",
            slug: "moulay-bousselham"
        },
        {
            name: "Sidi Allal Tazi",
            slug: "sidi-allal-tazi"
        },
        {
            name: "Sidi Kacem",
            slug: "sidi-kacem"
        },
        {
            name: "Sidi Slimane",
            slug: "sidi-slimane"
        },
        {
            name: "Sidi Taibi",
            slug: "sidi-taibi"
        },
        {
            name: "Sidi Yahya El Gharb",
            slug: "sidi-yahya-el-gharb"
        },
        {
            name: "Souk El Arbaa",
            slug: "souk-el-arbaa"
        },
        {
            name: "Akka",
            slug: "akka"
        },
        {
            name: "Assa",
            slug: "assa"
        },
        {
            name: "Bouizakarne",
            slug: "bouizakarne"
        },
        {
            name: "El Ouatia",
            slug: "el-ouatia"
        },
        {
            name: "Es-Semara",
            slug: "es-semara"
        },
        {
            name: "Fam El Hisn",
            slug: "fam-el-hisn"
        },
        {
            name: "Foum Zguid",
            slug: "foum-zguid"
        },
        {
            name: "Guelmim",
            slug: "guelmim"
        },
        {
            name: "Taghjijt",
            slug: "taghjijt"
        },
        {
            name: "Tan-Tan",
            slug: "tan-tan"
        },
        {
            name: "Tata",
            slug: "tata"
        },
        {
            name: "Zag",
            slug: "zag"
        },
        {
            name: "Marrakech",
            slug: "marrakech"
        },
        {
            name: "Ait Daoud",
            slug: "ait-daoud"
        },
        {
            name: "Amizmiz",
            slug: "amizmiz"
        },
        {
            name: "Assahrij",
            slug: "assahrij"
        },
        {
            name: "Aït Ourir",
            slug: "ait-ourir"
        },
        {
            name: "Ben Guerir",
            slug: "ben-guerir"
        },
        {
            name: "Chichaoua",
            slug: "chichaoua"
        },
        {
            name: "El Hanchane",
            slug: "el-hanchane"
        },
        {
            name: "El Kelaâ des Sraghna",
            slug: "el-kelaa-des-sraghna"
        },
        {
            name: "Essaouira",
            slug: "essaouira"
        },
        {
            name: "Fraïta",
            slug: "fraita"
        },
        {
            name: "Ghmate",
            slug: "ghmate"
        },
        {
            name: "Ighounane",
            slug: "ighounane"
        },
        {
            name: "Imintanoute",
            slug: "imintanoute"
        },
        {
            name: "Kattara",
            slug: "kattara"
        },
        {
            name: "Lalla Takerkoust",
            slug: "lalla-takerkoust"
        },
        {
            name: "Loudaya",
            slug: "loudaya"
        },
        {
            name: "Lâattaouia",
            slug: "laattaouia"
        },
        {
            name: "Moulay Brahim",
            slug: "moulay-brahim"
        },
        {
            name: "Mzouda",
            slug: "mzouda"
        },
        {
            name: "Ounagha",
            slug: "ounagha"
        },
        {
            name: "Sid L'Mokhtar",
            slug: "sid-lmokhtar"
        },
        {
            name: "Sid Zouin",
            slug: "sid-zouin"
        },
        {
            name: "Sidi Abdallah Ghiat",
            slug: "sidi-abdallah-ghiat"
        },
        {
            name: "Sidi Bou Othmane",
            slug: "sidi-bou-othmane"
        },
        {
            name: "Sidi Rahhal",
            slug: "sidi-rahhal"
        },
        {
            name: "Skhour Rehamna",
            slug: "skhour-rehamna"
        },
        {
            name: "Smimou",
            slug: "smimou"
        },
        {
            name: "Tafetachte",
            slug: "tafetachte"
        },
        {
            name: "Tahannaout",
            slug: "tahannaout"
        },
        {
            name: "Talmest",
            slug: "talmest"
        },
        {
            name: "Tamallalt",
            slug: "tamallalt"
        },
        {
            name: "Tamanar",
            slug: "tamanar"
        },
        {
            name: "Tamansourt",
            slug: "tamansourt"
        },
        {
            name: "Tameslouht",
            slug: "tameslouht"
        },
        {
            name: "Tanalt",
            slug: "tanalt"
        },
        {
            name: "Meknès",
            slug: "meknes"
        },
        {
            name: "Khénifra",
            slug: "khenifra"
        },
        {
            name: "Agourai",
            slug: "agourai"
        },
        {
            name: "Ain Taoujdate",
            slug: "ain-taoujdate"
        },
        {
            name: "MyAliCherif",
            slug: "myalicherif"
        },
        {
            name: "Rissani",
            slug: "rissani"
        },
        {
            name: "Amalou Ighriben",
            slug: "amalou-ighriben"
        },
        {
            name: "Aoufous",
            slug: "aoufous"
        },
        {
            name: "Arfoud",
            slug: "arfoud"
        },
        {
            name: "Azrou",
            slug: "azrou"
        },
        {
            name: "Aïn Jemaa",
            slug: "ain-jemaa"
        },
        {
            name: "Aïn Karma",
            slug: "ain-karma"
        },
        {
            name: "Aïn Leuh",
            slug: "ain-leuh"
        },
        {
            name: "Aït Boubidmane",
            slug: "ait-boubidmane"
        },
        {
            name: "Aït Ishaq",
            slug: "ait-ishaq"
        },
        {
            name: "Boudnib",
            slug: "boudnib"
        },
        {
            name: "Boufakrane",
            slug: "boufakrane"
        },
        {
            name: "Boumia",
            slug: "boumia"
        },
        {
            name: "El Hajeb",
            slug: "el-hajeb"
        },
        {
            name: "Elkbab",
            slug: "elkbab"
        },
        {
            name: "Er-Rich",
            slug: "er-rich"
        },
        {
            name: "Errachidia",
            slug: "errachidia"
        },
        {
            name: "Gardmit",
            slug: "gardmit"
        },
        {
            name: "Goulmima",
            slug: "goulmima"
        },
        {
            name: "Gourrama",
            slug: "gourrama"
        },
        {
            name: "Had Bouhssoussen",
            slug: "had-bouhssoussen"
        },
        {
            name: "El Haj Kaddour",
            slug: "el-haj-kaddour"
        },
        {
            name: "Ifrane",
            slug: "ifrane"
        },
        {
            name: "Itzer",
            slug: "itzer"
        },
        {
            name: "Jorf",
            slug: "jorf"
        },
        {
            name: "Kehf Nsour",
            slug: "kehf-nsour"
        },
        {
            name: "Kerrouchen",
            slug: "kerrouchen"
        },
        {
            name: "M'haya",
            slug: "mhaya"
        },
        {
            name: "M'rirt",
            slug: "mrirt"
        },
        {
            name: "Midelt",
            slug: "midelt"
        },
        {
            name: "Moulay Ali Cherif",
            slug: "moulay-ali-cherif"
        },
        {
            name: "Moulay Bouazza",
            slug: "moulay-bouazza"
        },
        {
            name: "Moulay Idriss Zerhoun",
            slug: "moulay-idriss-zerhoun"
        },
        {
            name: "Moussaoua",
            slug: "moussaoua"
        },
        {
            name: "N'Zalat Bni Amar",
            slug: "nzalat-bni-amar"
        },
        {
            name: "Ouaoumana",
            slug: "ouaoumana"
        },
        {
            name: "Oued Ifrane",
            slug: "oued-ifrane"
        },
        {
            name: "Sabaa Aiyoun",
            slug: "sabaa-aiyoun"
        },
        {
            name: "Sebt Jahjouh",
            slug: "sebt-jahjouh"
        },
        {
            name: "Sidi Addi",
            slug: "sidi-addi"
        },
        {
            name: "Tichoute",
            slug: "tichoute"
        },
        {
            name: "Tighassaline",
            slug: "tighassaline"
        },
        {
            name: "Tighza",
            slug: "tighza"
        },
        {
            name: "Timahdite",
            slug: "timahdite"
        },
        {
            name: "Tinejdad",
            slug: "tinejdad"
        },
        {
            name: "Tizguite",
            slug: "tizguite"
        },
        {
            name: "Toulal",
            slug: "toulal"
        },
        {
            name: "Tounfite",
            slug: "tounfite"
        },
        {
            name: "Zaouia d'Ifrane",
            slug: "zaouia-difrane"
        },
        {
            name: "Zaïda",
            slug: "zaida"
        },
        {
            name: "Ahfir",
            slug: "ahfir"
        },
        {
            name: "Aklim",
            slug: "aklim"
        },
        {
            name: "Al Aroui",
            slug: "al-aroui"
        },
        {
            name: "Aïn Bni Mathar",
            slug: "ain-bni-mathar"
        },
        {
            name: "Aïn Erreggada",
            slug: "ain-erreggada"
        },
        {
            name: "Ben Taïeb",
            slug: "ben-taieb"
        },
        {
            name: "Berkane",
            slug: "berkane"
        },
        {
            name: "Bni Ansar",
            slug: "bni-ansar"
        },
        {
            name: "Bni Chiker",
            slug: "bni-chiker"
        },
        {
            name: "Bni Drar",
            slug: "bni-drar"
        },
        {
            name: "Bni Tadjite",
            slug: "bni-tadjite"
        },
        {
            name: "Bouanane",
            slug: "bouanane"
        },
        {
            name: "Bouarfa",
            slug: "bouarfa"
        },
        {
            name: "Bouhdila",
            slug: "bouhdila"
        },
        {
            name: "Dar El Kebdani",
            slug: "dar-el-kebdani"
        },
        {
            name: "Debdou",
            slug: "debdou"
        },
        {
            name: "Douar Kannine",
            slug: "douar-kannine"
        },
        {
            name: "Driouch",
            slug: "driouch"
        },
        {
            name: "El Aïoun Sidi Mellouk",
            slug: "el-aioun-sidi-mellouk"
        },
        {
            name: "Farkhana",
            slug: "farkhana"
        },
        {
            name: "Figuig",
            slug: "figuig"
        },
        {
            name: "Ihddaden",
            slug: "ihddaden"
        },
        {
            name: "Jaâdar",
            slug: "jaadar"
        },
        {
            name: "Jerada",
            slug: "jerada"
        },
        {
            name: "Kariat Arekmane",
            slug: "kariat-arekmane"
        },
        {
            name: "Kassita",
            slug: "kassita"
        },
        {
            name: "Kerouna",
            slug: "kerouna"
        },
        {
            name: "Laâtamna",
            slug: "laatamna"
        },
        {
            name: "Madagh",
            slug: "madagh"
        },
        {
            name: "Midar",
            slug: "midar"
        },
        {
            name: "Nador",
            slug: "nador"
        },
        {
            name: "Naima",
            slug: "naima"
        },
        {
            name: "Oued Heimer",
            slug: "oued-heimer"
        },
        {
            name: "Oujda",
            slug: "oujda"
        },
        {
            name: "Ras El Ma",
            slug: "ras-el-ma"
        },
        {
            name: "Saïdia",
            slug: "saidia"
        },
        {
            name: "Selouane",
            slug: "selouane"
        },
        {
            name: "Sidi Boubker",
            slug: "sidi-boubker"
        },
        {
            name: "Sidi Slimane Echcharraa",
            slug: "sidi-slimane-echcharraa"
        },
        {
            name: "Talsint",
            slug: "talsint"
        },
        {
            name: "Taourirt",
            slug: "taourirt"
        },
        {
            name: "Tendrara",
            slug: "tendrara"
        },
        {
            name: "Tiztoutine",
            slug: "tiztoutine"
        },
        {
            name: "Touima",
            slug: "touima"
        },
        {
            name: "Touissit",
            slug: "touissit"
        },
        {
            name: "Zaïo",
            slug: "zaio"
        },
        {
            name: "Zeghanghane",
            slug: "zeghanghane"
        },
        {
            name: "Rabat",
            slug: "rabat"
        },
        {
            name: "Salé",
            slug: "sale"
        },
        {
            name: "Ain El Aouda",
            slug: "ain-el-aouda"
        },
        {
            name: "Harhoura",
            slug: "harhoura"
        },
        {
            name: "Khémisset",
            slug: "khemisset"
        },
        {
            name: "Oulmès",
            slug: "oulmes"
        },
        {
            name: "Rommani",
            slug: "rommani"
        },
        {
            name: "Sidi Allal El Bahraoui",
            slug: "sidi-allal-el-bahraoui"
        },
        {
            name: "Sidi Bouknadel",
            slug: "sidi-bouknadel"
        },
        {
            name: "Skhirate",
            slug: "skhirate"
        },
        {
            name: "Tamesna",
            slug: "tamesna"
        },
        {
            name: "Témara",
            slug: "temara"
        },
        {
            name: "Tiddas",
            slug: "tiddas"
        },
        {
            name: "Tiflet",
            slug: "tiflet"
        },
        {
            name: "Touarga",
            slug: "touarga"
        },
        {
            name: "Agadir",
            slug: "agadir"
        },
        {
            name: "Agdz",
            slug: "agdz"
        },
        {
            name: "Agni Izimmer",
            slug: "agni-izimmer"
        },
        {
            name: "Aït Melloul",
            slug: "ait-melloul"
        },
        {
            name: "Alnif",
            slug: "alnif"
        },
        {
            name: "Anzi",
            slug: "anzi"
        },
        {
            name: "Aoulouz",
            slug: "aoulouz"
        },
        {
            name: "Aourir",
            slug: "aourir"
        },
        {
            name: "Arazane",
            slug: "arazane"
        },
        {
            name: "Aït Baha",
            slug: "ait-baha"
        },
        {
            name: "Aït Iaâza",
            slug: "ait-iaaza"
        },
        {
            name: "Aït Yalla",
            slug: "ait-yalla"
        },
        {
            name: "Ben Sergao",
            slug: "ben-sergao"
        },
        {
            name: "Biougra",
            slug: "biougra"
        },
        {
            name: "Boumalne-Dadès",
            slug: "boumalne-dades"
        },
        {
            name: "Dcheira El Jihadia",
            slug: "dcheira-el-jihadia"
        },
        {
            name: "Drargua",
            slug: "drargua"
        },
        {
            name: "El Guerdane",
            slug: "el-guerdane"
        },
        {
            name: "Harte Lyamine",
            slug: "harte-lyamine"
        },
        {
            name: "Ida Ougnidif",
            slug: "ida-ougnidif"
        },
        {
            name: "Ifri",
            slug: "ifri"
        },
        {
            name: "Igdamen",
            slug: "igdamen"
        },
        {
            name: "Ighil n'Oumgoun",
            slug: "ighil-noumgoun"
        },
        {
            name: "Imassine",
            slug: "imassine"
        },
        {
            name: "Inezgane",
            slug: "inezgane"
        },
        {
            name: "Irherm",
            slug: "irherm"
        },
        {
            name: "Kelaat-M'Gouna",
            slug: "kelaat-mgouna"
        },
        {
            name: "Lakhsas",
            slug: "lakhsas"
        },
        {
            name: "Lakhsass",
            slug: "lakhsass"
        },
        {
            name: "Lqliâa",
            slug: "lqliaa"
        },
        {
            name: "M'semrir",
            slug: "msemrir"
        },
        {
            name: "Massa (Maroc)",
            slug: "massa-maroc"
        },
        {
            name: "Megousse",
            slug: "megousse"
        },
        {
            name: "Ouarzazate",
            slug: "ouarzazate"
        },
        {
            name: "Oulad Berhil",
            slug: "oulad-berhil"
        },
        {
            name: "Oulad Teïma",
            slug: "oulad-teima"
        },
        {
            name: "Sarghine",
            slug: "sarghine"
        },
        {
            name: "Sidi Ifni",
            slug: "sidi-ifni"
        },
        {
            name: "Skoura",
            slug: "skoura"
        },
        {
            name: "Tabounte",
            slug: "tabounte"
        },
        {
            name: "Tafraout",
            slug: "tafraout"
        },
        {
            name: "Taghzout",
            slug: "taghzout"
        },
        {
            name: "Tagzen",
            slug: "tagzen"
        },
        {
            name: "Taliouine",
            slug: "taliouine"
        },
        {
            name: "Tamegroute",
            slug: "tamegroute"
        },
        {
            name: "Tamraght",
            slug: "tamraght"
        },
        {
            name: "Tanoumrite Nkob Zagora",
            slug: "tanoumrite-nkob-zagora"
        },
        {
            name: "Taourirt ait zaghar",
            slug: "taourirt-ait-zaghar"
        },
        {
            name: "Taroudannt",
            slug: "taroudannt"
        },
        {
            name: "Temsia",
            slug: "temsia"
        },
        {
            name: "Tifnit",
            slug: "tifnit"
        },
        {
            name: "Tisgdal",
            slug: "tisgdal"
        },
        {
            name: "Tiznit",
            slug: "tiznit"
        },
        {
            name: "Toundoute",
            slug: "toundoute"
        },
        {
            name: "Zagora",
            slug: "zagora"
        },
        {
            name: "Afourar",
            slug: "afourar"
        },
        {
            name: "Aghbala",
            slug: "aghbala"
        },
        {
            name: "Azilal",
            slug: "azilal"
        },
        {
            name: "Aït Majden",
            slug: "ait-majden"
        },
        {
            name: "Beni Ayat",
            slug: "beni-ayat"
        },
        {
            name: "Béni Mellal",
            slug: "beni-mellal"
        },
        {
            name: "Bin elouidane",
            slug: "bin-elouidane"
        },
        {
            name: "Bradia",
            slug: "bradia"
        },
        {
            name: "Bzou",
            slug: "bzou"
        },
        {
            name: "Dar Oulad Zidouh",
            slug: "dar-oulad-zidouh"
        },
        {
            name: "Demnate",
            slug: "demnate"
        },
        {
            name: "Dra'a",
            slug: "draa"
        },
        {
            name: "El Ksiba",
            slug: "el-ksiba"
        },
        {
            name: "Foum Jamaa",
            slug: "foum-jamaa"
        },
        {
            name: "Fquih Ben Salah",
            slug: "fquih-ben-salah"
        },
        {
            name: "Kasba Tadla",
            slug: "kasba-tadla"
        },
        {
            name: "Ouaouizeght",
            slug: "ouaouizeght"
        },
        {
            name: "Oulad Ayad",
            slug: "oulad-ayad"
        },
        {
            name: "Oulad M'Barek",
            slug: "oulad-mbarek"
        },
        {
            name: "Oulad Yaich",
            slug: "oulad-yaich"
        },
        {
            name: "Sidi Jaber",
            slug: "sidi-jaber"
        },
        {
            name: "Souk Sebt Oulad Nemma",
            slug: "souk-sebt-oulad-nemma"
        },
        {
            name: "Zaouïat Cheikh",
            slug: "zaouiat-cheikh"
        },
        {
            name: "Tanger",
            slug: "tanger"
        },
        {
            name: "Tétouan",
            slug: "tetouan"
        },
        {
            name: "Akchour",
            slug: "akchour"
        },
        {
            name: "Assilah",
            slug: "assilah"
        },
        {
            name: "Bab Berred",
            slug: "bab-berred"
        },
        {
            name: "Bab Taza",
            slug: "bab-taza"
        },
        {
            name: "Brikcha",
            slug: "brikcha"
        },
        {
            name: "Chefchaouen",
            slug: "chefchaouen"
        },
        {
            name: "Dar Bni Karrich",
            slug: "dar-bni-karrich"
        },
        {
            name: "Dar Chaoui",
            slug: "dar-chaoui"
        },
        {
            name: "Fnideq",
            slug: "fnideq"
        },
        {
            name: "Gueznaia",
            slug: "gueznaia"
        },
        {
            name: "Jebha",
            slug: "jebha"
        },
        {
            name: "Karia",
            slug: "karia"
        },
        {
            name: "Khémis Sahel",
            slug: "khemis-sahel"
        },
        {
            name: "Ksar El Kébir",
            slug: "ksar-el-kebir"
        },
        {
            name: "Larache",
            slug: "larache"
        },
        {
            name: "M'diq",
            slug: "mdiq"
        },
        {
            name: "Martil",
            slug: "martil"
        },
        {
            name: "Moqrisset",
            slug: "moqrisset"
        },
        {
            name: "Oued Laou",
            slug: "oued-laou"
        },
        {
            name: "Oued Rmel",
            slug: "oued-rmel"
        },
        {
            name: "Ouazzane",
            slug: "ouazzane"
        },
        {
            name: "Point Cires",
            slug: "point-cires"
        },
        {
            name: "Sidi Lyamani",
            slug: "sidi-lyamani"
        },
        {
            name: "Sidi Mohamed ben Abdallah el-Raisuni",
            slug: "sidi-mohamed-ben-abdallah-el-raisuni"
        },
        {
            name: "Zinat",
            slug: "zinat"
        },
        {
            name: "Ajdir",
            slug: "ajdir"
        },
        {
            name: "Aknoul",
            slug: "aknoul"
        },
        {
            name: "Al Hoceïma",
            slug: "al-hoceima"
        },
        {
            name: "Aït Hichem",
            slug: "ait-hichem"
        },
        {
            name: "Bni Bouayach",
            slug: "bni-bouayach"
        },
        {
            name: "Bni Hadifa",
            slug: "bni-hadifa"
        },
        {
            name: "Ghafsai",
            slug: "ghafsai"
        },
        {
            name: "Guercif",
            slug: "guercif"
        },
        {
            name: "Imzouren",
            slug: "imzouren"
        },
        {
            name: "Inahnahen",
            slug: "inahnahen"
        },
        {
            name: "Issaguen (Ketama)",
            slug: "issaguen-ketama"
        },
        {
            name: "Karia (El Jadida)",
            slug: "karia-el-jadida"
        },
        {
            name: "Karia Ba Mohamed",
            slug: "karia-ba-mohamed"
        },
        {
            name: "Oued Amlil",
            slug: "oued-amlil"
        },
        {
            name: "Oulad Zbair",
            slug: "oulad-zbair"
        },
        {
            name: "Tahla",
            slug: "tahla"
        },
        {
            name: "Tala Tazegwaght",
            slug: "tala-tazegwaght"
        },
        {
            name: "Tamassint",
            slug: "tamassint"
        },
        {
            name: "Taounate",
            slug: "taounate"
        },
        {
            name: "Targuist",
            slug: "targuist"
        },
        {
            name: "Taza",
            slug: "taza"
        },
        {
            name: "Taïnaste",
            slug: "tainaste"
        },
        {
            name: "Thar Es-Souk",
            slug: "thar-es-souk"
        },
        {
            name: "Tissa",
            slug: "tissa"
        },
        {
            name: "Tizi Ouasli",
            slug: "tizi-ouasli"
        },
        {
            name: "Laayoune",
            slug: "laayoune"
        },
        {
            name: "El Marsa",
            slug: "el-marsa"
        },
        {
            name: "Tarfaya",
            slug: "tarfaya"
        },
        {
            name: "Boujdour",
            slug: "boujdour"
        },
        {
            name: "Awsard",
            slug: "awsard"
        },
        {
            name: "Oued-Eddahab",
            slug: "oued-eddahab"
        },
        {
            name: "Stehat",
            slug: "stehat"
        },
        {
            name: "Aït Attab",
            slug: "ait-attab"
        }
    ]


export const ROLE_OPTIONS = (t?: TFunction) =>  [
    { label: t ? t("director") : "director", value: "director" },
    { label: t ? t("pedagogy-director") : "pedagogy-director", value: "pedagogy-director" },
    { label: t ? t("teacher") : "teacher", value: "teacher" },
    { label: t ? t("student") : "student", value: "student" },
    { label:t ? t("guardian") : "guardian", value: "guardian" },
    { label: t ? t("user") : "user", value: "user" },
    { label: t ? t("manager") : "manager", value: "manager" },
    { label: t ? t("admin") : "admin", value: "admin" },
];


